import { guideSteps } from "@/mocks/home";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Guide() {
  return (
    <section id="guide" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="How To Write"
          title="写回忆录的小方法"
          description="不必等文笔变好，也不必等到记忆齐全。下面这四步，是从大量普通人的回忆录里总结出来、最容易上手的写法。"
          align="center"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {guideSteps.map((item) => (
            <article
              key={item.step}
              className="relative flex flex-col bg-background-50 border border-background-200 rounded-lg p-5 md:p-6"
            >
              <span className="font-heading text-4xl font-bold text-primary-200">{item.step}</span>
              <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.text}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 md:mt-10 bg-secondary-100/70 border border-secondary-200 rounded-lg p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-5 md:gap-8">
          <span className="w-12 h-12 shrink-0 rounded-full bg-secondary-500 text-background-50 flex items-center justify-center">
            <i className="ri-lightbulb-flash-line text-2xl"></i>
          </span>
          <div className="flex-1">
            <h3 className="font-heading text-lg font-semibold text-secondary-950">
              一个简单的开始：先写今天
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-secondary-900">
              与其苦想「难忘的往事」，不如写下今天让你停顿了一下的那件事——一句问候、一阵风、一个熟悉的背影。
              它可能就是你回忆录的第一行，也可能是十年后你最想重读的一段。
            </p>
          </div>
          <a
            href="#subscribe"
            className="shrink-0 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-secondary-600 text-background-50 text-sm hover:bg-secondary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-send-line"></i>
            获取写作提示
          </a>
        </div>
      </div>
    </section>
  );
}